import React from 'react';
import Chip from '@mui/material/Chip';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';

/**
 * CompanyTestChip - Chip indicando que a empresa é marcada como "teste" (Admin Geral)
 */
function CompanyTestChip() {
  return (
    <Chip
      size="small"
      icon={<ScienceOutlinedIcon sx={{ fontSize: '14px !important' }} />}
      label="Teste"
      sx={{
        backgroundColor: '#EDE7F6',
        color: '#4527A0',
        fontWeight: 500,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
}

export default CompanyTestChip;
